module.exports = __webpack_public_path__ + "static/media/KW13_AS1.ce9ce47a.png";